import { render, staticRenderFns } from "./quality_work_detail.vue?vue&type=template&id=cfa6ca6e&scoped=true"
import script from "./quality_work_detail.vue?vue&type=script&lang=js"
export * from "./quality_work_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa6ca6e",
  null
  
)

export default component.exports